/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export default function Dialog(props) {
  const {
    state,
    dispatch,
    children,
    title,
    footer,
    className,
    dialogClassName,
    backdropClassName,
    bodyClassName,
    centered,
    closeButton,
    dialogRestProps,
    backdrop,
    confirmFunction,
  } = props;
  return (
    <Modal
      show={state?.isOpen}
      onHide={() => dispatch({ type: "TOGGLE" })}
      dialogClassName={dialogClassName}
      backdropClassName={backdropClassName}
      backdrop={backdrop}
      centered={centered}
      className={className}
      {...dialogRestProps}
    >
      {title && (
        <Modal.Header closeButton={closeButton}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}

      {children && (
        <Modal.Body className={bodyClassName}>{children}</Modal.Body>
      )}

      {footer && (
        <Modal.Footer>
          <Button variant="success" onClick={confirmFunction}>
            نعم
          </Button>
          <Button variant="danger" onClick={() => dispatch({ type: "TOGGLE" })}>
            لا
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

Dialog.defaultProps = {
  children: null,
  footer: true,
  dialogClassName: "",
  bodyClassName: "",
  backdropClassName: "",
  className: "",
  title: "",
  centered: false,
  closeButton: false,
  dialogRestProps: {},
  backdrop: true,
  // formName: "",
  // buttonType: "button",
  // submitHandler: () => {},
  confirmFunction: () => {},
};

Dialog.propTypes = {
  state: PropTypes.shape({ isOpen: PropTypes.bool }).isRequired,
  dispatch: PropTypes.func.isRequired,
  title: PropTypes.string,
  dialogClassName: PropTypes.string,
  backdropClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  className: PropTypes.string,
  footer: PropTypes.bool,
  centered: PropTypes.bool,
  closeButton: PropTypes.bool,
  // formName: PropTypes.string,
  // submitHandler: PropTypes.func,
  // buttonType: PropTypes.string,
  children: PropTypes.node,
  dialogRestProps: PropTypes.object,
  backdrop: PropTypes.bool,
  confirmFunction: PropTypes.func,
};
